import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const entityRoutes = {
    FIND_BY_NAME_OR_IDENTIFICATION: "dashboard/core/entity/findByNameOrIdentification",
    FIND_BY_IDENTIFICATION: "dashboard/core/entity/find-identification-list"
};

export default {
    findByNameOrIdentificationAutocomplete(criteria) {
        return new Promise(resolve => {
            this.findByNameOrIdentificationAutocomplete(criteria)
                .then(info => {
                    const list = info.map(item => ({label: item.title, id: item.code, code: item.code}));
                    resolve(list);
                });
        });
    },
    findByNameOrIdentification(criteria) {
        return new Promise(resolve => {
            let newData = [];
            http.get(entityRoutes.FIND_BY_NAME_OR_IDENTIFICATION,
                {params: {criteria}}
            ).then(({data}) => {
                const code = data.code;
                if (code === 0) {
                    toast.info("No se encontrarón personas y/o empresas")
                    return;
                }
                if (code < 0) {
                    toast.error("Error al consultar las empresas y/o personas");
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("Error al consultar las empresas y/o personas"))
                .finally(() => resolve(newData));
        })
    },
    findByIdentification(identification) {
        return new Promise(resolve => {
            let newData = [];
            http.get(entityRoutes.FIND_BY_IDENTIFICATION,
                {params: {identification}}
            ).then(({data}) => {
                const code = data.code;
                if (code === 0) {
                    toast.info("No se encontrarón personas y/o empresas")
                    return;
                }
                if (code < 0) {
                    toast.error("Error al consultar las empresas y/o personas");
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("Error al consultar las empresas y/o personas"))
                .finally(() => resolve(newData));
        })
    }



};